/* Livli header: menu drawer, desktop dropdowns, rotating announcement bar. */
(function () {
  function init(root) {
    var wrap = (root || document).querySelector('[data-lv-header]');
    if (!wrap || wrap.__lvInit) return;
    wrap.__lvInit = true;

    var drawer = wrap.querySelector('[data-lv-drawer]');
    var openBtn = wrap.querySelector('[data-lv-open]');
    var closeBtn = wrap.querySelector('[data-lv-close]');

    function open() {
      drawer.hidden = false;
      document.documentElement.classList.add('lv-lock');
      openBtn.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add('is-open'); }); });
      setTimeout(function () { closeBtn && closeBtn.focus(); }, 60);
    }
    function close() {
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('lv-lock');
      openBtn.setAttribute('aria-expanded', 'false');
      setTimeout(function () { drawer.hidden = true; }, 380);
      openBtn.focus();
    }
    openBtn && openBtn.addEventListener('click', open);
    closeBtn && closeBtn.addEventListener('click', close);
    drawer && drawer.addEventListener('click', function (e) { if (e.target.closest('a')) { document.documentElement.classList.remove('lv-lock'); } });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && !drawer.hidden) close();
      if (e.key === 'Tab' && drawer && !drawer.hidden) {
        var f = drawer.querySelectorAll('a, button, summary');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    window.addEventListener('resize', function () { if (window.innerWidth > 900 && drawer && !drawer.hidden && drawer.offsetWidth === window.innerWidth) close(); });

    /* desktop dropdowns: one open at a time, close on outside click */
    var dds = wrap.querySelectorAll('[data-lv-dd]');
    dds.forEach(function (d) {
      d.addEventListener('toggle', function () { if (d.open) dds.forEach(function (o) { if (o !== d) o.open = false; }); });
    });
    document.addEventListener('click', function (e) { dds.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; }); });

    /* announcement bar rotation */
    var ann = wrap.querySelector('[data-lv-ann]');
    if (ann) {
      var msgs = ann.querySelectorAll('.lv-ann__msg'), i = 0;
      if (msgs.length > 1 && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
        setInterval(function () { msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on'); }, 4000);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
